module.exports = __webpack_public_path__ + "img/2.8f8a0d3c.jpg";